import React from 'react'
import PropTypes from 'prop-types'
import {Table} from 'reactstrap'
import ImportItemsItem from './ImportItemsItem'

class ImportItemsTable extends React.Component {
    _parseProductsItems = (items) => {
        const results = []

        for (let item of items) {
            const {products, ...itemWithoutProducts} = item
            if (!Array.isArray(products) || products.length === 0) continue

            const firstProduct = products[0]
            const listProducts = products.slice(1)

            const {mockUpFront, mockUpBack, designFront, designBack, size, color, quantity, type} = firstProduct
            results.push(Object.assign({}, itemWithoutProducts, {
                mockUpFront,
                mockUpBack,
                designFront,
                designBack,
                type,
                size,
                color,
                quantity,
                isShow: true
            }))

            for (let itemProduct of listProducts) {
                const {
                    mockUpFront: mockUpFrontItem,
                    mockUpBack: mockUpBackItem,
                    designFront: designFrontItem,
                    designBack: designBackItem,
                    type,
                    size: sizeItem,
                    color: colorItem,
                    quantity: quantityItem
                } = itemProduct
                results.push({
                    mockUpFront: mockUpFrontItem,
                    mockUpBack: mockUpBackItem,
                    designFront: designFrontItem,
                    designBack: designBackItem,
                    type: type,
                    size: sizeItem,
                    color: colorItem,
                    quantity: quantityItem,
                    isShow: false
                })
            }
        }

        return results
    }

    render() {
        const {items, ...rest} = this.props
        const parsedItems = this._parseProductsItems(items)

        return (
            <div className='ImportItemsTable'>
                <Table responsive>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Order Number</th>
                            <th>Market Place</th>
                            <th>Mock Up Front</th>
                            <th>Mock Up Back</th>
                            <th>Design Front</th>
                            <th>Design Back</th>
                            <th>Type</th>
                            <th>Size</th>
                            <th>Color</th>
                            <th>Quantity</th>
                            <th>Address</th>
                            <th>Return Address</th>
                            <th>Generate label config</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            parsedItems.map((item, i) => {
                                return <ImportItemsItem {...rest} key={i} index={i} item={item} />
                            })
                        }
                    </tbody>
                </Table>
            </div>
        )
    }
}

ImportItemsTable.propTypes = {
    items: PropTypes.array.isRequired
}

export default ImportItemsTable
